/**
 * Cookie Banner
 *
 * @class rlCookies
 * @memberOf jQuery.fn
 */

(function ($) {
  $.fn.rlCookiesVisitID = function () {
    var RLVisitID = {

      RLCookieName: 'RlVisitId',
      currentRLVisitID: '',
      domain: '',

      createRLVisitID: function () {
        'use strict';

        var newUUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0,
              v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });

        return newUUID;

      },

      calculateDomain: function () {
        'use strict';
        var regex = new RegExp(/\./g);
        var domainTemp = document.location.hostname.toString();
        var count = 0;
        try {
          count = domainTemp.match(regex).length;
        } catch (err) { }

        if (count > 1) {
          domainTemp = domainTemp.substring(domainTemp.indexOf('.') + 1);
          domainTemp = ';domain=' + domainTemp;
        } else {
          domainTemp = ';domain=' + domainTemp;
        }

        RLVisitID.domain = domainTemp;
      },

      setCookie: function () {
        'use strict';

        if (RLVisitID.domain !== '') {
          RLVisitID.domain;
        }

        document.cookie = encodeURIComponent(RLVisitID.RLCookieName) + '=' + encodeURIComponent(RLVisitID.currentRLVisitID) + RLVisitID.domain + ';path=/';
      },

      getCookie: function () {
        'use strict';
        ///<summary>Return the value of the RlVisitId, or null if it does not exist</summary>

        var regex = new RegExp('(?:^|;)\\s?' + RLVisitID.RLCookieName + '=(.*?)(?:;|$)', 'i');
        var result = document.cookie.match(regex);

        return (result === null) ? null : unescape(result[1]);
      },

      documentReady: function () {
        'use strict';

        RLVisitID.calculateDomain();

        RLVisitID.currentRLVisitID = RLVisitID.getCookie();

        if (RLVisitID.currentRLVisitID === null) {
          // No current cookie - create a unique ID
          RLVisitID.currentRLVisitID = RLVisitID.createRLVisitID();
        }

        RLVisitID.setCookie();

      }
    };

    window.onload = function () {

      'use strict';

      RLVisitID.documentReady();
    };
  };

}(jQuery));

/**
 * rlCookiesVisitID() is called by GTM.
 */
if (typeof rlCookiesVisitID === 'undefined') { 
  window['rlCookiesVisitID'] = function() {
    $().rlCookiesVisitID();
  }
}
